import { render, staticRenderFns } from "./PatentNei.vue?vue&type=template&id=20f104d0&scoped=true"
import script from "./PatentNei.vue?vue&type=script&lang=js"
export * from "./PatentNei.vue?vue&type=script&lang=js"
import style0 from "./PatentNei.vue?vue&type=style&index=0&id=20f104d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f104d0",
  null
  
)

export default component.exports